import { CountUp } from 'countup.js';
import { Slider } from '../../../../../bd-site/Resources/Private/JavaScript/Slider.js';

export class CounterSliderClass {
    constructor(slider) {
        this.slider = slider;
        if (!this.slider) {
            return;
        }

        // Reuse the shared slider engine as the source of truth; only the
        // count-up-on-visible behaviour below is specific to the counter.
        this.swiper = new Slider(this.slider, JSON.stringify({
            slidesPerView: {xs: 1, sm: 1, md: 3, lg: 3, xl: 6},
            spaceBetween: 1,
            rewind: true,
            arrows: 'outside',
        }));

        this.observeCounters();
    }

    observeCounters() {
        // Start each count-up only once its slide becomes visible. Intersection
        // is clipped by the slider's overflow, so counters on slides that are
        // scrolled off — vertically on the page or horizontally in the slider —
        // animate only after they are brought into view.
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }
                entry.target.classList.add('inView');
                new CountUpClass(entry.target);
                observer.unobserve(entry.target);
            });
        }, {threshold: 0.5});

        this.slider.querySelectorAll('[data-counter-number]').forEach((counter) => {
            observer.observe(counter);
        });
    }
}

export class CountUpClass {
    constructor(counter) {
        if (!counter) return;
        const number = counter.getAttribute('data-counter-number');
        if (!number) return;
        const finalNumber = Number(number.replace(',', '.'));
        const decimalPlaces = (number.replace(',', '.').split('.')[1] || '').length;
        const numberFormat = counter.getAttribute('data-counter-number-format');

        let useGrouping = true;
        let separator = ',';
        let decimal = '.';

        switch (numberFormat) {
            case '2':
                separator = '.';
                decimal = ',';
                break;
            case '3':
                useGrouping = false;
                break;
            case '4':
                break;
            case '5':
                separator = ' ';
                decimal = ',';
                break;
            case '6':
                separator = ' ';
                break;
            default:
                useGrouping = false;
                decimal = ',';
                break;
        }

        const countUp = new CountUp(counter, finalNumber, {
            startVal: 0,
            decimalPlaces: decimalPlaces,
            useGrouping: useGrouping,
            separator: separator,
            decimal: decimal,
            autoAnimate: true,
            autoAnimateOnce: true,
            duration: 2,
        });
        if (!countUp.error) {
            countUp.start();
        } else {
            console.error(countUp.error);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-counter-slider]').forEach((item) => {
        new CounterSliderClass(item);
    });
});
